module.exports = __webpack_public_path__ + "static/fonts/iconfont.ca79d2a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font/iconfont.ttf?t=1741155911033
// module id = xbZW
// module chunks = 141